@if (showTitle) {
<h2 mat-dialog-title class="!text-xl font-extrabold text-slate-900 border-b border-slate-100 p-6 !m-0">
    {{ title }}
</h2>
}

<mat-dialog-content class="!p-6 !m-0">
    <div class="text-[0.98rem] text-slate-600 leading-6">{{ message }}</div>
    @if (showDetail) {
    <div class="mt-4 p-3 bg-slate-50 border border-slate-200 rounded-lg text-xs text-slate-400 italic">
        {{ detail }}
    </div>
    }
</mat-dialog-content>

<div mat-dialog-actions class="flex justify-end gap-3 p-6 !m-0 !pt-2">
    <button mat-stroked-button (click)="dialogRef.close(dialogResult)" class="!border-slate-200 !text-slate-500 !font-semibold !px-6">
        {{ textCancel }}
    </button>
    <button mat-flat-button color="primary" (click)="onOk()" class="!font-bold !px-8 !shadow-none">
        {{ textOk }}
    </button>
</div>
